var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 48C10.7472 48 0 37.2528 0 24C0 10.7472 10.7472 0 24 0C37.2528 0 48 10.7472 48 24C48 37.2528 37.2528 48 24 48Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2736 16.2767C38.9088 14.8943 37.8288 13.8095 36.456 13.4399C33.9696 12.7679 24.0048 12.7679 24.0048 12.7679C24.0048 12.7679 14.0352 12.7679 11.5536 13.4399C10.1808 13.8095 9.1008 14.8943 8.736 16.2767C8.064 18.7775 8.064 23.9999 8.064 23.9999C8.064 23.9999 8.064 29.2223 8.7312 31.7231C9.096 33.1055 10.176 34.1903 11.5488 34.5599C14.0352 35.2319 24 35.2319 24 35.2319C24 35.2319 33.9696 35.2319 36.4512 34.5599C37.824 34.1903 38.904 33.1055 39.2688 31.7231C39.936 29.2223 39.936 23.9999 39.936 23.9999C39.936 23.9999 39.936 18.7775 39.2736 16.2767ZM20.7408 28.7375V19.2623L29.0688 23.9999L20.7408 28.7375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon-3.8e946a4fd79f8f9467b859d200983a4f.svg";
export { ForwardRef as ReactComponent };